import React, { useEffect, useState } from 'react'; 
import Sidebar from './Layouts/Sidebar'; 
import './../Assets/CSS/Style.css';  
import inputStyles from './../Assets/CSS/Input.module.css'; 
import axios from 'axios'; 
import { BASE_URL } from './../Environment';
import { toast } from 'react-toastify'; 
import { IoSearch } from 'react-icons/io5';
import { FaArrowCircleRight } from 'react-icons/fa';
        
function Blood() { 
    const location = localStorage.getItem('location');  
    const [isLoading, setIsLoading] = useState(false);
    const [blood, setBlood] = useState([]);
    const [searchQuery, setSearchQuery] = useState(''); 
    useEffect(() => {
        document.title = 'Infomart | Sub Category'; 
    }, []);     
    const handleBloodGroup = (event) => {
        const value = event.target.value;
        setIsLoading(true);
        axios.get(`${BASE_URL}/blood/${value}/${location}`, {
            headers: {    
                'Content-Type': 'application/json'
            }
        }).then((res) => { 
            setBlood(res.data.data); 
            setIsLoading(false); 
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });  
    } 
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    }; 
 const filteredBlood = blood.filter((data) => {
        const query = searchQuery.toLowerCase();
        return ( 
            data.house_no?.toLowerCase().includes(query) ||
            data.road_name?.toLowerCase().includes(query) ||
            data.pincode?.toLowerCase().includes(query) ||
            data.district?.toLowerCase().includes(query) ||
            data.state?.toLowerCase().includes(query)
        );
    });  
    return (
        <div className="app"> 
            <div className="outlet">
                <div className="homeLayout">
                    <Sidebar />  
                    <div className="row justify-content-center">  
                        <div className="col-12">
                            <select className={inputStyles.dropdown} onChange={handleBloodGroup}>  
                                <option value="" selected disabled>Select Blood Group</option>
                                <option value="A+">A+</option>  
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>  
                            </select>     
                            {isLoading ?
                                <h5 className="text-center mt-5">Loading...</h5> 
                            :  
                                <>
                                    <div className="inputContainer mx-auto w-100 mt-2"> 
                                        <input type="text" className="input" value={searchQuery} placeholder="Search..." onChange={handleSearchChange} />
                                        <IoSearch color="rgb(18,95,220)" /> 
                                    </div>  
                                    {filteredBlood.length > 0 ? ( 
                                        <ul className="mt-4">
                                            {filteredBlood?.map((data, i) => (
                                                <li className="mt-2" key={i}><FaArrowCircleRight /> {data.name} ({data.house_no}, {data.road_name}, {data.district}, {data.state}, {data.pincode}) +91 {data.phone}</li>
                                            ))}              
                                        </ul>   
                                    ) : (
                                        <p className="mx-auto text-danger fw-bold mt-5">No results found.</p>
                                    )}  
                                </>   
                            }  
                        </div> 
                    </div> 
                </div>
            </div> 
        </div>
    );
}

export default Blood;         